module.exports = __webpack_public_path__ + "img/photo-of-a-wooden-bookshelf-2883049.b9c398c0.jpg";